import { StrictMode } from 'react'
import './i18n'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { installChunkLoadRecovery, notifyAppLoadedStable } from '@/lib/chunkLoadRecovery'

// ── Global stale-chunk recovery ──
// Detecta errores reales de chunk obsoleto (tras un deploy nuevo) y hace
// UNA SOLA recarga automática para traer el build vigente. No afecta la
// navegación SPA normal.
installChunkLoadRecovery();

// Intercept Supabase recovery/invite tokens that land on the root URL
// and redirect to the correct page BEFORE React mounts
(function interceptAuthHash() {
  const hash = window.location.hash;
  if (!hash) return;
  const params = new URLSearchParams(hash.replace('#', ''));
  const type = params.get('type');
  const token = params.get('access_token');
  if (token && (type === 'recovery' || type === 'invite')) {
    const base = (window as any).__BASE_PATH__ || '/';
    const basePath = base.endsWith('/') ? base.slice(0, -1) : base;
    window.location.replace(`${basePath}/portal/reset-password${hash}`);
  }
})();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)

// Una vez la app se mantiene estable (sin errores de chunk), liberamos el
// flag de recuperación para que un incidente futuro (otro deploy) pueda
// volver a recuperarse una sola vez.
window.setTimeout(() => {
  notifyAppLoadedStable();
}, 5000)
